import {
	Legend,
	LegendLiElement,
} from "../../../../../components/charts/Legend";
import AutoSizer from "react-virtualized-auto-sizer";
import {
	DonutOptions,
	PieChartWithLabels,
	PieChartWithLabelsRow,
} from "../../../../../dashboard/widgets/charts/PieChartWithLabels";
import * as React from "react";
import { LegendItem } from "../../pages/CensusSummaryPage/types";
import { Display } from "../../../../../components/Display";
import { LegendTooltip } from "../../../../../dashboard/widgets/unilever/LegendTooltip";
import { AppTranslations } from "../../../../../components/Utils/translations/AppTranslations";

declare var AppTranslations: AppTranslations;

interface CensusOkPieChartProps {
	data: PieChartWithLabelsRow[];
	legendData: LegendItem[];
	cartLegendClassName: string;
	chartClassName: string;
	noDataMessage: string;
	donutOptions?: DonutOptions;
	labelLineDefaultLength?: number;
	radiusRatio?: number;
	otherLegendData?: LegendItem[];
	title?: string;
}

export const CensusStatusPieChart: React.FC<CensusOkPieChartProps> = ({
	data,
	legendData,
	cartLegendClassName,
	chartClassName,
	noDataMessage,
	donutOptions,
	labelLineDefaultLength,
	radiusRatio,
	otherLegendData,
	title,
}) => {
	const [selectedItem, setSelectedItem] = React.useState<string>();
	const [tooltipConfig, setTooltipConfig] = React.useState<any>({
		visible: false,
	});

	const onOtherTooltipHover = (_, e) => null;

	const selectItem = (itemName: string, e) => {
		const target: HTMLLIElement = e ? e.currentTarget : null;
		setSelectedItem(itemName);
		if (
			target &&
			itemName
				?.toLowerCase()
				.includes(AppTranslations.genericWords.other.toLowerCase())
		) {
			setTooltipConfig({
				visible: true,
				offSetX: target.offsetLeft,
				offSetY: target.offsetTop + target.offsetHeight,
				width: target.offsetWidth,
				data: otherLegendData,
				father: target,
			});
		}
	};

	return (
		<>
			<Display isVisible={title}>
				<h2 className={"title"}>{title}</h2>
			</Display>
			<div className={cartLegendClassName}>
				<Legend
					items={legendData ?? []}
					selectedItemName={selectedItem}
					onItemHover={selectItem}
					showValues={true}
					singleColumn={true}
				/>
				<LegendTooltip
					config={tooltipConfig}
					className={"tooltip-wrapper"}
					style={{
						color: "white",
					}}
				>
					{(otherLegendData: LegendItem[]) => (
						<div
							className={"tooltip-body"}
							style={{
								maxHeight: 200,
								overflow: "auto",
							}}
						>
							<ul className="legend">
								{otherLegendData.map((item, i) => (
									<LegendLiElement
										key={i}
										item={{
											name: item.name,
											color: item.color,
											code: item.name,
											// icon: row.icon,
											value: item.value,
											percentage: item.percentage,
										}}
										iconOptions={{ show: false }}
										// onClick={onOtherTooltipClicked(equipment.label)}
										showValues={true}
										liStyle={{
											color: "white",
										}}
										onHover={onOtherTooltipHover}
									/>
								))}
							</ul>
						</div>
					)}
				</LegendTooltip>
			</div>
			<div className={chartClassName}>
				<AutoSizer>
					{({ width, height }) => (
						<PieChartWithLabels
							data={data}
							selectedItem={selectedItem}
							onPathOver={selectItem}
							height={height}
							width={width}
							donutOptions={
								donutOptions ?? {
									activeDonut: true,
									showTotal: true,
									totalSize: "20px ",
								}
							}
							showPercentage={true}
							showIcon={false}
							labelLineDefaultLength={labelLineDefaultLength ?? 20}
							labelsOptions={{ externalLegend: true }}
							noDataMessage={noDataMessage}
							radiusRatio={radiusRatio ?? 2}
							order={"custom"}
						/>
					)}
				</AutoSizer>
			</div>
		</>
	);
};
